import Config from '@config';
import { ReferenceBook } from '@gasbi/shared';

import { injectAdminSlice } from '@/app/adminApi';
import { CreateAdminOrganizationRequest } from '@/features/adminOrganization/types';

import { OnboardingStatusReadModel } from './types';

export const onboardingApi = injectAdminSlice({
  baseUrl: `${Config.VITE_API_URL}/onboarding`,
  tagTypes: ['OnboardingStatus'],
  endpoints: builder => ({
    getOnboardingStatus: builder.query<OnboardingStatusReadModel, void>({
      query: () => ({ url: '', method: 'GET' }),
      providesTags: ['OnboardingStatus'],
    }),
    createOnboardingOrganization: builder.mutation<
      string,
      CreateAdminOrganizationRequest
    >({
      query: data => ({
        url: '',
        method: 'POST',
        data,
      }),
    }),
    getOnboardingDepartments: builder.query<ReferenceBook[], void>({
      query: () => ({ url: '/departments', method: 'GET' }),
    }),
    getOnboardingPositions: builder.query<ReferenceBook[], void>({
      query: () => ({ url: '/positions', method: 'GET' }),
    }),
  }),
});

export const {
  useGetOnboardingStatusQuery,
  useCreateOnboardingOrganizationMutation,
  useGetOnboardingDepartmentsQuery,
  useGetOnboardingPositionsQuery,
} = onboardingApi;
